<template>
  <div id="app">
    <router-view></router-view>

  </div>
</template>

<script>
import { store } from './store/index'
import router from './router/index'

export default {
  name: 'app',
  components: {
  },
  beforeCreate() {
    if (!store.state.isLogged) {
      router.push('/login')
    }
  }
}
</script>

<style>
@import '../node_modules/bulma/css/bulma.css';
@import '../node_modules/cool-checkboxes-for-bulma.io/dist/css/bulma-radio-checkbox.min.css';

html {
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

body {
  height: 100%;
}

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.leaflet-bar-part>.fa{
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?a769dd40